module.exports = __webpack_public_path__ + "img/Monster-painting-on-the-wall.9ceefca2.png";